import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TasacionesService } from '../../services/tasaciones.service';
import { DateHelper } from './../../models/NgDateCustomAdapter';
import { TasacionArchivoValues } from './../../models/enums';

import { map } from 'rxjs/operators';
import { ControlLookupComponent } from '../control-lookup/control-lookup.component';

import { Observable } from 'rxjs';
import { TasacionArchivo } from '../../models/TasacionArchivo';
import { ClientesService } from '../../services/clientes.service';
import { LocalizationService } from '../../services/localization.service';

import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';

import * as moment from 'moment';
import { SalesPerson } from '../../models/SalesPerson';
import { ClientesComponent } from '../clientes/clientes.component';

import * as $ from 'jquery';
import { ApiResult } from '../../models/ApiResult';
import { ValidacionService } from '../../services/validacion.service';
// declare var $: any;

import { MatDialog, MatDialogConfig } from '@angular/material';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ErrorHelper } from '../../models/ErrorHelper';
import { ModelHelpers } from '../../models/ModelHelpers';
import { TasacionModel, ValoresEstadoTasacion, ValoresLiquidacionTecnicaAcordada } from '../../models/TasacionModel';
import { CanalEntrada } from '../../models/canal-entrada.model';
import { PSTasacionModel } from '../../models/ps-tasacion-model';
import { CanalEntradaService } from '../../services/canal-entrada.service';
import { ContratosService } from '../../services/contratos.service';
import { erpInvoiceService } from '../../services/erp-invoice.service';
import { GlobalUIUtilsService } from '../../services/global-ui-utils.service';
import { PsDatosGeneralesService } from '../../services/ps-datos-generales.service';
import { PsTasacionService } from '../../services/ps-tasacion.service';
import { ReclamacionesService } from '../../services/reclamaciones.service';
import { TecnicoService } from '../../services/tecnico.service';
import { ValidadorServiceService } from '../../services/validador-service.service';
import { AgUploadTemporalFilesComponent } from '../ag-upload-temporal-files/ag-upload-temporal-files.component';
import { ModalDefaultComponent } from '../controls/modal-default/modal-default.component';
import { IncidenciaCloseComponent } from '../incidencias-edit/incidencia-close/incidencia-close.component';
import { PsDatosGeneralesListComponent } from '../proyectos-significativos/ps-datos-generales-list/ps-datos-generales-list.component';
import { TasacionReclamacionEditComponent } from '../tasacion-reclamacion-edit/tasacion-reclamacion-edit.component';
import { DialogComponent } from '../dialog/dialog.component';
import { TasacionEditPsFormComponent } from './tasacion-edit-ps-form/tasacion-edit-ps-form.component';
import { PrescriptorService } from '../../services/prescriptor.service';
import { PrescriptorComponent } from '../prescriptor/prescriptor.component';



@Component({
  selector: 'app-tasacion-edit',
  templateUrl: './tasacion-edit.component.html',
  styles: [`
    agm-map {
      height: 600px;
    }
  `],
  styleUrls: ['./tasacion-edit.component.css',]
})
export class TasacionEditComponent implements OnInit, AfterViewInit {

  tasacionForm: FormGroup;
  @ViewChild('places', { static: false }) places: GooglePlaceDirective;
  @ViewChild('lookupCliente', { static: true }) lookupCliente: ControlLookupComponent;
  @ViewChild('lookupClienteSolicitante', { static: true }) lookupClienteSolicitante: ControlLookupComponent;
  @ViewChild('fileUpload', { static: false }) fileUpload: AgUploadTemporalFilesComponent;
  @ViewChild('lookupPS', { static: false }) lookupPS: ControlLookupComponent;
  @ViewChild('lookupPrescriptor', { static: false }) lookupPrescriptor: ControlLookupComponent;

  modelo: TasacionModel;
  title = 'Crear';
  isNewElement: boolean;
  id: number;
  lat: number;
  long: number;
  incidenciasList: any;
  incidencias = true;
  tipoInmuebleList: any;
  clienteslist: any;
  usersList: any;
  estadoList: any;
  entidadFinancieraIdList: any;
  finalidadList: any;
  tecnicoList: any = [];
  visitadorList: any = [];
  validadorList: any;
  psList: any;
  contratoslist: any = [];
  ficherosTasacionList: Observable<TasacionArchivo[]>;
  temporalFilesAdded: File[] = [];
  ficherosInformeList: Observable<TasacionArchivo[]>;
  ficherosVisitaList: Observable<TasacionArchivo[]>;
  validacion: boolean;
  salesPersonList: Observable<SalesPerson>;
  oficinaFacturacionList: any;
  canalEntradaList: any;
  prescriptorList: any;
  copias: number = 1;
  errorMessage: string = '';
  isES: boolean;
  isPT: boolean;
  isProvDisabled: boolean = false;

  isEdit: boolean = false;
  categorizacionAbcList: any[] = [
    { id: "A", displayName: "A- Cliente con facturación anual recurrente superior a 30.000 €/Presupuesto superior a 20.000 €/Cliente-prescriptor estratégico para Valtecsa" },
    { id: "B", displayName: "B - Cliente a recuperar/presupuesto superior a 10.000 €/Cliente-prescriptor estratégico para la Oficina" },
    { id: "C", displayName: "C - Resto" }];
  buttonAddTecnicoDisable: boolean = false;
  nTecnicosAgregados: number = 1;
  tecnicosAgregados: any[] = [];
  tecnicosForm: FormGroup;
  tecnicosFormArray: FormArray;
  ps_t: PSTasacionModel;
  tecnicosRList: any;
  erpInvoiceList: any;


  // -----------------------------------------------Variables que utilizo para activar pestañas----------------------//
  CestadoId: null;
  CresponsableId: null;
  CfechaIntento: null;
  CfechaInformeEnviado: null;
  ChaSidoValidado: null;
  CResultadoVisita: null;

  modalTitulo: string;
  modalMensaje: string;

  options: any = {
    format: 'DD/MM/YYYY'
  };

  interval: any;
  needRefreshArchivos: Boolean;

  modelCanalEntrada: CanalEntrada;
  isTasacionCompleta: boolean;
  reopenVisitEnabled: boolean;

  liqTecnicaAcordadaValues: { label: string, value: number }[] = [];
  valoresLiquidacionTecnicaAcordada = ValoresLiquidacionTecnicaAcordada;
  dialogConfig: MatDialogConfig;
  showOpenIncidenciaBtn = false;
  showCloseIncidenciaBtn = false;
  showOpenReclamacionBtn = false;
  showCloseReclamacionBtn = false;
  showAnularReclamacion = false;
  showAsignarPS = false;

  reclamacionesList: any;
  hideReclamaciones = true;
  showValidacionMessage = false;

  validacionTime: any;
  reclamacionTime: any;
  incidenciaTime: any;
  psTasacion: any;
  showPsTab: boolean = false;

  customFieldNamesError = {
    visita: 'visita',
    responsableID: 'responsable',
    tipoInmuebleId: 'tipología',
    clienteId: 'cliente',
    entidadFinancieraId: 'entidad financiera',
    fechaPedido: 'fecha de pedido',
    finalidadId: 'finalidad de la tasación',
    contratoId: 'contrato',
    descripcion: 'descripción',
    canalEntradaId: 'canal de entrada',
    tasadorId: 'técnico',
    tipoTasacion: 'tipo tasación',
    prescriptorId: 'prescriptor',
    tecnicoID: 'técnico adicional'
    // Agrega más campos y sus nombres personalizados según sea necesario

  };

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, private localization: LocalizationService, private _location: Location,
    private _TasacionesService: TasacionesService, public _authService: AuthService, private _clientesService: ClientesService,
    private _router: Router, private location: Location, public dateHelper: DateHelper, public _validacionService: ValidacionService, public _canalEntradaService: CanalEntradaService,
    config: NgbModalConfig, private modalService: NgbModal, private _globalUIUtilsService: GlobalUIUtilsService, private ref: ChangeDetectorRef,
    private _contratosService: ContratosService, private _validadorService: ValidadorServiceService, private _tecnicoService: TecnicoService, public _dialog: MatDialog,
    private _erpInvoiceService: erpInvoiceService, private _ReclamacionesService: ReclamacionesService, public matDialog: MatDialog,
    private _psTasacionService: PsTasacionService, private _psService: PsDatosGeneralesService, private _prescriptorService: PrescriptorService) {

    this.modelo = new TasacionModel();

    config.backdrop = 'static';
    config.keyboard = false;

    if (this._authService.authDataCache.pais == 'ES')
      this.isES = true;

    if (this._authService.authDataCache.pais == 'PT')
      this.isPT = true;

    if (this._authService.authDataCache.pais == '*') {
      this.isES = true;
      this.isPT = true;
    }

    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
      this.isEdit = true;
    } else {
      this.id = 0;
    }

    this.showPsTab = this.id > 0;



    this.tasacionForm = this._fb.group({
      // -----------------------------------------------Datos necesarios-----------------------------------------------------//
      id: 0,
      visita: [{
        value: '',
        disabled: !(this._authService.authDataCache.gestor) && !this.isEdit
      }, [Validators.required]],
      estadoId: [{
        value: 100,
        disabled: true
      },
      [Validators.required]],
      responsableID: [{ value: null, disabled: this.isEdit }, [Validators.required]],
      // -----------------------------------------------Pestaña 1. General----------------------------------------------------//
      tipoInmuebleId: [{
        value: '',
        disabled: !(this._authService.authDataCache.gestor)
      },
      [Validators.required]],
      clienteId: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.required]],
      clienteSolicitanteId: [{
        value: null,
        disabled: !(this._authService.authDataCache.gestor)
      }],
      clienteSolicitanteDescr: [''],
      solicitanteLibre: ['', [Validators.maxLength(60)]],
      entidadFinancieraId: [{
        value: '',
        disabled: !(this._authService.authDataCache.gestor)
      }, [Validators.required]],
      referenciaBanco: [{
        value: '',
        disabled: !(this._authService.authDataCache.gestor)
      }, [Validators.maxLength(50)]],
      referenciaBanco2: [{
        value: '',
        disabled: !(this._authService.authDataCache.gestor)
      }, [Validators.maxLength(50)]],
      nPresupuesto: [{
        value: '',
        disabled: !(this._authService.authDataCache.gestor)
      }, [Validators.maxLength(20)]],
      estadosFacturacionId: [{ value: null, disabled: true }],
      codigoTasacion: [{ value: '', disabled: true }],
      fechaPedido: [{
        value: dateHelper.dateFormat_iso(new Date()),
        disabled: !(this._authService.authDataCache.gestor)
      },
      [Validators.required]],
      fechaPresupuesto: [{
        value: dateHelper.dateFormat_iso(new Date()),
        disabled: !(this._authService.authDataCache.gestor)
      }],
      distrito: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(50)]],
      concejo: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(50)]],
      provincia: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(50)]],
      barrio: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(50)]],
      localidad: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(50)]],
      direccion: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(250)]],
      piso: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(5)]],
      puerta: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(50)]],
      codPostal: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(20)]],
      freguesia: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(50)]],
      pais: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.maxLength(50)]],
      finalidadId: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.required]],
      contratoId: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.required]],
      descripcion: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.required, Validators.maxLength(200)]],
      descripcionLarga: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }],
      comentariosInternos: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }],
      textoFactura: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }],

      oficinaFacturacionId: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }],
      canalEntradaId: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }, [Validators.required]],
      prescriptorId: [{ value: null, disabled: !(this._authService.authDataCache.gestor) }],
      deadline: [{ value: dateHelper.dateFormat_iso(new Date()), disabled: !(this._authService.authDataCache.gestor) }],
      categorizacionABC: [{ value: '', disabled: !(this._authService.authDataCache.gestor) }],
      importePresupuestado: [{ value: 0, disabled: !(this._authService.authDataCache.gestor) }],
      provision: [{ value: false, disabled: !(this._authService.authDataCache.gestor) }],
      importeProvision: [{ value: 0, disabled: true }],
      liqTecnicaAcordada: [0],
      liqTecnicaAcordada_Importe: [{ value: 0, disabled: true }],
      liqTecnicaAcordada_Porcentaje: [{ value: 0, disabled: true }],
      // -----------------------------------------------Pestaña 2. Tecnico-----------------------------------------------------//
      tasadorId: [{ value: null, disabled: !(this._authService.authDataCache.gestor) }, [Validators.required]],
      fechaAsignacionTecnico: [{ value: '', disabled: true }],

      // -----------------------------------------------Pestaña 3. Visitas-----------------------------------------------------//
      fechaIntento: [{
        value: null,
        disabled: !(this._authService.authDataCache.gestor || this._authService.authDataCache.tecnico)
      },
      [Validators.nullValidator],
      ],
      resultadoVisita: [{ value: null, disabled: !(this._authService.authDataCache.gestor || this._authService.authDataCache.tecnico) }],
      visitaComentario: [{ value: '', disabled: !(this._authService.authDataCache.gestor || this._authService.authDataCache.tecnico) }],
      // visitador: [''],
      visitadorId: [{ value: null, disabled: !(this._authService.authDataCache.gestor || this._authService.authDataCache.tecnico) }],

      // -----------------------------------------------Pestaña 4. Informe-----------------------------------------------------//
      fechaInformeEnviado: [{
        value: null,
        disabled: !(this._authService.authDataCache.gestor || this._authService.authDataCache.tecnico)
      },
      [Validators.nullValidator]
      ],
      // -----------------------------------------------Pestaña 5. Validador---------------------------------------------------//
      fechaInformeValidado: [{ value: null, disabled: true }],
      valorTasacion: [{ value: null, disabled: !(this._authService.authDataCache.gestor || this._authService.authDataCache.validador) }],
      // validador: [''],
      validadorId: [{ value: null, disabled: !(this._authService.authDataCache.gestor) }],
      // tslint:disable-next-line: max-line-length
      haSidoValidado: [{ value: false, disabled: !(this._authService.authDataCache.gestor || this._authService.authDataCache.validador) }],

      // -----------------------------------------------Pestaña 6. Entrega------------------------------------------------------//
      // tslint:disable-next-line: max-line-length
      fechaInformeEntregadoCliente: [{ value: null, disabled: !(this._authService.authDataCache.gestor || this._authService.authDataCache.validador) }],
      haSidoEntregado: [false],
      importeFacturable: [{ value: '', disabled: true }],
      importeEditable: [false],
      facturable: [{ value: false, disabled: !(this._authService.authDataCache.gestor || this._authService.authDataCache.validador) }],
      // -----------------------------------------------Facturación //
      salesPersonCode: ['', [Validators.maxLength(20)]],
      contacto_NombreCompleto: ['', [Validators.maxLength(100)]],
      contacto_Telefono: ['', [Validators.maxLength(20)]],
      contacto_Email: ['', [Validators.maxLength(50)]],
      fechaFacturado: [''],
      // -----------------------------------------------Datos de auditoría------------------------------------------------------//
      estadoIncidencia: [''],
      long: [null],
      lat: [null],
      tipoTasacion: [{ value: true, disabled: !(this._authService.authDataCache.gestor) }, [Validators.required]],
      version: [{ value: '', disabled: true }],
      importeFacturado: [0],
      createdDate: [''],
      clienteDescr: [''],
      isDuplicada: [false],
      // -----------------------------------------Datos de Proyecto Significativo-----------------------------------------------//
      idps: [{value: null, disabled: true}]
    });

    this.tecnicosFormArray = this._fb.array([]);




    //Cambio para españa
    if (!this.isPT) {
      this.tasacionForm.controls['tipoTasacion'].disable();
      this.tasacionForm.controls['tipoTasacion'].setValue('true');
      //this.refreshCamposCanal();
    }

    if (this.isES) { // ESP por defecto será false = Administrativa
      this.tasacionForm.controls['tipoTasacion'].setValue('true');
    }
    if (this.isPT) { // Valores por defecto en PT
      this.tasacionForm.controls['tipoTasacion'].setValue('false');
      this.tasacionForm.controls['visita'].setValue(true);

    }

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.closeOnNavigation = true;
    this.dialogConfig.width = '850px';
    this.dialogConfig.maxHeight = '80%';

  }
  ngAfterViewInit(): void {
    if (this.showPsTab && this.lookupPS) {
      this.lookupPS.serviceSource = (query: string) => {
        return this._psService.getPSLookup(query);
      };
      this.lookupPS.serviceSourceById = (id: number) => {
        if (id != null) {
          return this._psService.getPSLookupId(id);
        }
      };

      this.lookupPS.advancedLookupComponent = PsDatosGeneralesListComponent;
    }
  }

  loadTecnicosData() {

    this._TasacionesService.getTecnicosData(this.id).subscribe(data => {
      this.tecnicosRList = data;
      if (this.tecnicosRList.length != 0) {
        this.tecnicosRList.forEach((tecnico) => {
          let isDisabledImporte = tecnico.liqTecnicaAcordada != ValoresLiquidacionTecnicaAcordada.Importe && (this._authService.authDataCache.gestor);
          let isDisabledPorcentaje = tecnico.liqTecnicaAcordada != ValoresLiquidacionTecnicaAcordada.Porcentaje && (this._authService.authDataCache.gestor);

          console.log(tecnico)
          const tecnicoFormGroup = this._fb.group({
            tecnicoID: [tecnico.tecnicoID],
            intervencion: [tecnico.intervencion],
            liqTecnicaAcordada: [tecnico.liqTecnicaAcordada == null ? 0 : tecnico.liqTecnicaAcordada],
            liqTecnicaAcordada_Importe: [{ value: tecnico.liqTecnicaAcordada_Importe == null ? 0 : tecnico.liqTecnicaAcordada_Importe, disabled: isDisabledImporte }],
            liqTecnicaAcordada_Porcentaje: [{ value: tecnico.liqTecnicaAcordada_Porcentaje == null ? 0 : tecnico.liqTecnicaAcordada_Porcentaje, disabled: isDisabledPorcentaje }]
          });

          this.tecnicosFormArray.push(tecnicoFormGroup)
        })
      }
    })
  }

  loadFacturacionData() {
    this._erpInvoiceService.getTasacionInvoices(this.id)
      .subscribe(data => {
        this.erpInvoiceList = data;
      });
  }

  loadPsData() {
    this._psTasacionService.getFromTasacion(this.id).subscribe(
      (data: any) => {
        this.tasacionForm.patchValue({
          idps: data.psRef,
        })
      }
    )
  }

  asignarPS() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '30%';
    // dialogConfig.maxWidth = '550px';
    dialogConfig.data = {
      title: 'Asociar Proyecto Significativo',
      // message: 'Selecciona del listado el proyecto significativo para asociar a esta tasación',
      confirmText: 'Aceptar',
      component: TasacionEditPsFormComponent,
      id: this.id
    };

    const ref = this.matDialog.open(DialogComponent, dialogConfig);

    ref.afterClosed().subscribe(result => {

      if (result === true) {
        const cInstance = ref.componentInstance.componentRef.instance;
        const isSaved = cInstance.onSubmit();
        // console.log(result);
        // console.log(ref);
        if (isSaved) {
          this.loadPsData();

        }
      }
    });
  }

  async onSaveCallback(cInstance: any): Promise<boolean> {
    let result = false;

    if (await cInstance.onSubmit()) {
      // this.loadPsData();
      console.log('guardado onSaveCallback')
      result = true;
    } else {
      result = false;
    }

    return result;
  }


  async refreshCamposCanal() {
    let canalEntradaContorl = this.tasacionForm.controls['canalEntradaId'];

    if (canalEntradaContorl !== undefined) {
      let canalEntradaId: number = this.tasacionForm.controls['canalEntradaId'].value;

      if (canalEntradaId !== null && canalEntradaId !== 0) {

        this.modelCanalEntrada = await this._canalEntradaService.get(canalEntradaId).toPromise();

        if (this.modelCanalEntrada != null) {
          //Comprueba que el filtro entidad de canal de entrada es 'PV', que se corresponde con contratos privados
          if (this.modelCanalEntrada.filtroEntidad == 'PV') {

            if (this.contratoslist != null) {
              //Filtra el contrato con id = PV (que se corresponde con los privados)
              this.contratoslist = this.contratoslist.filter(x => x.tipoContratoId !== this.modelCanalEntrada.filtroEntidad);
            }
          } else {
            this._contratosService.searchContratos().subscribe(data => this.contratoslist = data)
          }
        }
      }
    }
  }

  onChangeCanal() {
    this.refreshCamposCanal();
  }

  onChangeOficinaFact() {
    let oficinaFact = '';
    oficinaFact = this.tasacionForm.controls['oficinaFacturacionId'].value;
    this.salesPersonList = this._TasacionesService.getSalesPerson(oficinaFact);
  }

  ngOnInit() {
    this._globalUIUtilsService.show();

    this._authService.authIsLoaded.then(v => {
      this.formInit();
      this.loadCombos();
      this.loadTecnicosData();
      this.loadFacturacionData();
      this.loadPsData();
    });

    this.onValueChanges();

  }

  loadCombos() {
    this.liqTecnicaAcordadaValues = Object.keys(this.valoresLiquidacionTecnicaAcordada).filter((key) => isNaN(Number(key)))
      .map((key) => ({
        // label: key, value: this.valoresLiquidacionTecnicaAcordada[key]
        label: this.formatLabel(key), // Llamar a la función auxiliar para personalizar el label
        value: this.valoresLiquidacionTecnicaAcordada[key]
      }))
    console.log(this.liqTecnicaAcordadaValues)
  }

  formatLabel(str: string): string {
    // Remplazar las mayúsculas después de la primera letra por espacios y cambiar a minúsculas
    return str.charAt(0).toUpperCase() + str.slice(1).replace(/([A-Z])/g, ' $1').toLowerCase();
  }

  // Aquí comprobamos cuando un campo cambia, y habilitamos, deshabilitamos, filtramos según lo requerido
  onValueChanges() {
    //Cuando provision es true, se habilita el campo "importe provisión"
    this.tasacionForm.get('provision').valueChanges.subscribe((value: boolean) => {
      const provision = this.tasacionForm.get('importeProvision');
      if (value && (this._authService.authDataCache.gestor)) {
        provision.enable(); // Habilitar el campo
      } else {
        provision.disable(); // Deshabilitar el campo
        provision.setValue(0);
      }
    });

    this.tasacionForm.get('liqTecnicaAcordada').valueChanges.subscribe((value: number) => {
      const liqTecnicaImporte = this.tasacionForm.get('liqTecnicaAcordada_Importe');
      const liqTecnicaPorcentaje = this.tasacionForm.get('liqTecnicaAcordada_Porcentaje');
      this.disableLiqTecnicaFields(liqTecnicaImporte, liqTecnicaPorcentaje, value);
    });
  }

  // Cuando se selecciona una opción de liqTecnicaAcordada, se habilitan o deshabilitan los campos correspondientes en técnicos adicionales
  onChangeLiqTecnicaRTas(value: number, index: number) {
    const tecnicoFormGroup = this.tecnicosFormArray.at(index);
    const liqTecnicaImporte = tecnicoFormGroup.get('liqTecnicaAcordada_Importe');
    const liqTecnicaPorcentaje = tecnicoFormGroup.get('liqTecnicaAcordada_Porcentaje');
    this.disableLiqTecnicaFields(liqTecnicaImporte, liqTecnicaPorcentaje, value);
  };

  disableLiqTecnicaFields(liqTecnicaImporte: AbstractControl, liqTecnicaPorcentaje: AbstractControl, value: number) {
    if (value == ValoresLiquidacionTecnicaAcordada.Importe && (this._authService.authDataCache.gestor)) {
      liqTecnicaImporte.enable();  // Habilitar el campo
      liqTecnicaPorcentaje.disable();
      liqTecnicaPorcentaje.setValue(0);
    } else if (value == ValoresLiquidacionTecnicaAcordada.Porcentaje && (this._authService.authDataCache.gestor)) {
      liqTecnicaPorcentaje.enable(); // Habilitar el campo
      liqTecnicaImporte.disable(); // Deshabilitar el campo
      liqTecnicaImporte.setValue(0);
    } else {
      liqTecnicaImporte.disable(); // Deshabilitar el campo
      liqTecnicaImporte.setValue(0);
      liqTecnicaPorcentaje.disable(); // Deshabilitar el campo
      liqTecnicaPorcentaje.setValue(0);
    }
  }

  refreshContratos(): void {
    const prescriptorId = this.tasacionForm.value.prescriptorId !== null ? this.tasacionForm.value.prescriptorId : '';
    const clienteId = this.tasacionForm.value.clienteId !== null ? this.tasacionForm.value.clienteId : '';
    this._contratosService.searchContratos(prescriptorId, clienteId).subscribe(data => {
      this.contratoslist = data;
      if (this.contratoslist.length > 1) {
        this.tasacionForm.patchValue({
          contratoId: this.contratoslist[1].id
        })
      } else if (this.contratoslist.length === 1) {
        this.tasacionForm.patchValue({
          contratoId: this.contratoslist[0].id
        })
      }

    });
  }

  async formInit() {

    //Cargamos las listas
    this._TasacionesService.getTipoInmuebles().subscribe(data => this.tipoInmuebleList = data);
    this._TasacionesService.getClientes().subscribe(data => this.clienteslist = data);
    this._TasacionesService.getUsers().subscribe(data => this.usersList = data);
    this._TasacionesService.getEstadoTasaciones().subscribe(data => this.estadoList = data);
    this._TasacionesService.getEntidadesFinancieras().subscribe(data => this.entidadFinancieraIdList = data);
    this._TasacionesService.getFinalidad().subscribe(data => this.finalidadList = data);
    this._tecnicoService.getTecnicos().subscribe(data => {
      this.tecnicoList = data;
      this.visitadorList = this.tecnicoList.filter(x => x.visitador);
    });
    this._validadorService.getValidadores().subscribe(data => this.validadorList = data);
    this._contratosService.searchContratos().subscribe(data => this.contratoslist = data);
    this._psService.getSectorList().subscribe(data => this.psList = data);

    this._TasacionesService.getOficinasFacturacion().subscribe(data => this.oficinaFacturacionList = data);
    this._TasacionesService.getCanalesEntrada().subscribe(data => this.canalEntradaList = data);
    // this._TasacionesService.getPrescriptores().subscribe(data => this.prescriptorList = data);


    // Asignamos la forma de recuperar el Lookup de clientes, que es una Lambda string => Observable<LookupData>
    // Configurar Lookups
    this.lookupCliente.serviceSource = (query: string) => {
      return this._clientesService.getClientesLookup(query);
    };
    this.lookupCliente.serviceSourceById = (id: number) => {
      if (id != null) {
        return this._clientesService.getClientesLookupId(id);
      }
    };

    this.lookupCliente.advancedLookupComponent = ClientesComponent;

    this.lookupClienteSolicitante.serviceSource = this.lookupCliente.serviceSource;
    this.lookupClienteSolicitante.serviceSourceById = this.lookupCliente.serviceSourceById;
    this.lookupClienteSolicitante.advancedLookupComponent = ClientesComponent;

     this.lookupPrescriptor.serviceSource = (query: string) => {
      return this._prescriptorService.getPrescriptorLookup(query);
    };
    this.lookupPrescriptor.serviceSourceById = (id: number) => {
      if (id != null) {
        return this._prescriptorService.getPrescriptorLookupId(id);
      }
    };

    this.lookupPrescriptor.advancedLookupComponent = PrescriptorComponent



    //mostrar archivos
    this.needRefreshArchivos = true;
    this.refreshArchivos();

    // Cargar datos principales

    if (this.id > 0) {
      this.isNewElement = false;
      this.title = 'Editar';
      let resp: TasacionModel = null;
      try {
        resp = await this._TasacionesService.getTasacionID(this.id).toPromise();
        console.log(resp)
      }
      catch (error) {
        console.log(error);
        this.errorMessage = error; this.back();
      }

      if (resp == null) {
        this._router.navigate(['/tasaciones']);
      }
      this.modelo = resp;

      this.showAlertMessage();
      this.tasacionForm.patchValue(resp);
      this.tasacionForm.patchValue({
        liqTecnicaAcordada_Importe: this.modelo.liqTecnicaAcordada_Importe == null ? 0 : this.modelo.liqTecnicaAcordada_Importe,
        liqTecnicaAcordada_Porcentaje: this.modelo.liqTecnicaAcordada_Porcentaje == null ? 0 : this.modelo.liqTecnicaAcordada_Porcentaje,
        fechaIntento: this.modelo.fechaIntento != null ? this.dateHelper.dateFormat_iso(this.modelo.fechaIntento) : null,
        fechaInformeEnviado: this.modelo.fechaInformeEnviado != null ? this.dateHelper.dateFormat_iso(this.modelo.fechaInformeEnviado) : null,
      })
      console.log(this.tasacionForm)
      this.onChangeOficinaFact();

      this.CestadoId = this.tasacionForm.controls['estadoId'].value;
      this.CresponsableId = this.tasacionForm.controls['tasadorId'].value;
      this.CfechaIntento = this.tasacionForm.controls['fechaIntento'].value;
      this.CfechaInformeEnviado = this.tasacionForm.controls['fechaInformeEnviado'].value;
      this.ChaSidoValidado = this.tasacionForm.controls['haSidoValidado'].value;
      this.CResultadoVisita = this.tasacionForm.controls['resultadoVisita'].value;
      this.checkEditable();
      this.tasacionForm.controls['importeFacturable'].enable();
      this.lat = this.tasacionForm.controls['lat'].value;
      this.long = this.tasacionForm.controls['long'].value;
      this.tasacionForm.controls['tipoTasacion'].disable();
      this.tasacionForm.controls['idps'].disable();

      this.displayButtons();


      if (this.modelo.visita == true && this.modelo.estadoId >= 150 && this.modelo.estadoId <= 900 && this.modelo.estadoId !== 502) {
        this.reopenVisitEnabled = true;
      }

      if (resp.tipoTasacion == false) {
        this.isTasacionCompleta = true;
      }
      else {
        this.isTasacionCompleta = false;
      }
      console.log(this.modelo)
      if (this.modelo.isDuplicada === true) {
        this.tasacionForm.controls['responsableID'].enable();
      }

    } else {
      this.isNewElement = true;
    }


    this._globalUIUtilsService.hide();
  }

  showAlertMessage() {
    this._TasacionesService.getIncidencias(this.id).subscribe(data => {
      this.incidenciasList = data;
      if (this.incidenciasList.estado !== 'Error') {
        this.incidencias = false;
        this.incidenciaTime = data[0].fechaInicio;
      } else {
        this.incidencias = true;
      }
    }
    );

    this._ReclamacionesService.getAllByTasID(this.id).subscribe((data: any) => {
      this.reclamacionesList = data;
      if (this.reclamacionesList.estado !== 'Error') {
        this.hideReclamaciones = false;
        this.reclamacionTime = data[0].fechaInicio;
      } else {
        this.hideReclamaciones = true;
      }
    }
    );
    if (this.modelo.estadoId === ValoresEstadoTasacion.InformeEnviado && new Date(this.modelo.fechaInformeEnviado) < new Date()) {
      this.showValidacionMessage = true;
      this.validacionTime = this.modelo.fechaInformeEnviado;
      // this.validacionTime = `Fecha de envío del informe: ${this.dateHelper.dateFormat_es(this.modelo.fechaInformeEnviado)}`;
    } else {
      this.showValidacionMessage = false;
    }

  }

  public moment(data) {
    if (data == null || data === '') {
      return null;
    }
    return moment.utc(data).local().format('DD/MM/YYYY');
  }

  // -----------------------------------------------Al seleccionar una dirección el resto de parametros se establecen de forma automatica
  public onChange(address: any) {
    this.tasacionForm.controls['direccion'].setValue(address.formatted_address);
    console.log('Address components:');
    console.log(address.address_components);
    for (let i = 0; i < address.address_components.length; i++) {
      if (address.address_components[i].types[0] === 'locality') {
        this.tasacionForm.controls['localidad'].setValue(address.address_components[i].long_name);
      } else if (address.address_components[i].types[0] === 'administrative_area_level_2') {
        // NO USAR this.tasacionForm.controls['concejo'].setValue(address.address_components[i].long_name);
        this.tasacionForm.controls['provincia'].setValue(address.address_components[i].long_name);
      } else if (address.address_components[i].types[0] === 'administrative_area_level_1') {
        // Comunidad autonoma
        this.tasacionForm.controls['distrito'].setValue(address.address_components[i].long_name);
      } else if (address.address_components[i].types[0] === 'postal_code') {
        this.tasacionForm.controls['codPostal'].setValue(address.address_components[i].long_name);
      } else if (address.address_components[i].types[0] === 'country') {
        this.tasacionForm.controls['pais'].setValue(address.address_components[i].long_name);
      }
    }
    var p = address.geometry.location;

    var latA = "&";
    var longA = "&";

    latA = latA.replace('&', p.lat());
    longA = longA.replace('&', p.lng());

    this.tasacionForm.controls['lat'].setValue(p.lat());
    this.tasacionForm.controls['long'].setValue(p.lng());
  }


  // -------------------------------------------------------Funciones de archivos----------------------------------------//
  refreshArchivos() {
    if (this.needRefreshArchivos) {
      if (this.id !== undefined) {
        const svcGeneric = this._TasacionesService.getArchivosTasacion(this.id);
        this.ficherosTasacionList = svcGeneric;

        this.ficherosInformeList = svcGeneric.pipe(
          map((d) => {
            return d.filter(d2 => d2.tipoArchivo === TasacionArchivoValues.Informe);
          }
          ));

        this.ficherosVisitaList = svcGeneric.pipe(
          map((d) => {
            return d.filter(d2 => d2.tipoArchivo === TasacionArchivoValues.Fotos);
          }
          ));
      }
    }
  }

  onFileUploaded(event) {
    this.needRefreshArchivos = true;
    this.refreshArchivos();

  }

  FileDelete(TasacionArchivoID) {
    this._TasacionesService.removeArchivoTasacion(TasacionArchivoID).subscribe(data => {
      this.needRefreshArchivos = true;
      this.refreshArchivos();
    });
  }

  // -----------------------------------------------Guardado y recogida de datos--------------------------------------//
  getData() {
    this._TasacionesService.getTasacionID(this.id)
      .subscribe((resp: any) => {
        if (resp.estado === 'Error') {
          this._router.navigate(['/tasaciones']);
        }

        this.modelo = resp;
        this.tasacionForm.patchValue(resp);
        this.tasacionForm.patchValue({
          fechaIntento: this.modelo.fechaIntento != null ? this.dateHelper.dateFormat_iso(this.modelo.fechaIntento) : null,
          fechaInformeEnviado: this.modelo.fechaInformeEnviado != null ? this.dateHelper.dateFormat_iso(this.modelo.fechaInformeEnviado) : null,
        })
        this.CestadoId = this.tasacionForm.controls['estadoId'].value;
        this.CresponsableId = this.tasacionForm.controls['tasadorId'].value;
        this.CfechaIntento = this.tasacionForm.controls['fechaIntento'].value;
        this.CfechaInformeEnviado = this.tasacionForm.controls['fechaInformeEnviado'].value;
        this.ChaSidoValidado = this.tasacionForm.controls['haSidoValidado'].value;
        this.CResultadoVisita = this.tasacionForm.controls['resultadoVisita'].value;

        this.tasacionForm.markAsPristine();
        this.loadPsData();

        this.displayButtons();
        this.checkEditable();
        this.showAlertMessage();
        this.ref.detectChanges();

        if (this.modelo.isDuplicada === true) {
          this.tasacionForm.controls['responsableID'].enable();
        } else {
          this.tasacionForm.controls['responsableID'].disable();
        }


      }, error => {
        this.errorMessage = error;
        this.back();
      });

  }

  tryBack() {
    this.back();
  }

  onAfterDuplicate(value: ApiResult | null) {
    if (value.correct) {
      $('#myModal').modal('hide');
      this.errorMessage = 'Duplicación correcta';
    }
    else {
      if (value != null) {
        this.errorMessage = value.mensaje;
      }
      else {
        this.errorMessage = 'Error interno';
      }
    }
  }

  duplicar(copias) {
    if (copias > 0) {
      this._TasacionesService.duplicarTasacion(this.id, copias)
        .subscribe({
          next: (apiResult: ApiResult) => {
            if (apiResult.correct) {
              this.onAfterDuplicate(apiResult);
            }
            else {
              this.onAfterDuplicate(apiResult);
            }
          },
          error: (error) => {

          }
        });
    }
  }

  back() {
    this._location.back();
  }

  backSave() {

    this.saveAsync().then((result: string) => {
      if (result !== null) {
        $('#mensajeGuardar').modal('hide');
        this._router.navigate(['/tasaciones']);
      }
    });
  }

  save() {
    this.saveAsync().then((routeUrl: string) => {
      if (routeUrl !== null) {
        this._router.navigate([routeUrl]);
      }
    });
  }

  async saveAsync(): Promise<string> {
    let tasacionModel = new TasacionModel();
    let routeUrl = null;
    ModelHelpers.copyFromForm(this.tasacionForm.getRawValue(), tasacionModel);
    tasacionModel.tipoTasacion = (this.tasacionForm.controls['tipoTasacion'].value === "true");

    console.log(tasacionModel);
    
    // Convertir prescriptorId vacío a null para que el backend pueda procesarlo como int?
    if (!tasacionModel.prescriptorId || (tasacionModel.prescriptorId as any) === '') {
      tasacionModel.prescriptorId = null;
    }

    this.errorMessage = '';

    if (!this.tasacionForm.valid) {
      this.errorMessage = this.getFormValidationErrors();
      $('#errorModal').modal('show');
      // this.errorMessage = 'Por favor, complete todos los campos requeridos';
    } else {
      if (this.isNewElement) {
        try {
          this._globalUIUtilsService.show();
          let response: any = await this._TasacionesService.postTasacion(tasacionModel).toPromise();
          await this.fileUpload.onClickSubmit(response.mensaje);
          await this.saveTecnicos(response.mensaje);

          console.log(response);

          if (response.correct === false) {
            this.errorMessage = response.mensaje;
          }

          routeUrl = `/tasacion/edit/${response.mensaje}`;
        }
        catch (error) {

          this.errorMessage = ErrorHelper.GetClientError(error);

        } finally {
          this._globalUIUtilsService.hide();
        }

      } else {

        //Cuando la tasación va a cambiar de estado, aparece un popup para notificar al usuario.
        const { showConfirmation, message } = this.checkNextStatus(tasacionModel);

        if (showConfirmation) {
          var result = await this.confirmAnswer(message);
          if (result == false) {
            return;
          }
        }

        try {
          this._globalUIUtilsService.show();
          console.log(tasacionModel);
          let response: any = await this._TasacionesService.updateTasacion(this.id, tasacionModel).toPromise();
          console.log(response);
          await this.saveTecnicos(response.mensaje);
          // await this.savePS(response.mensaje);

          this.tasacionForm.reset();
          this.getData();
        } catch (error) {
          this.errorMessage = ErrorHelper.GetClientError(error);
        } finally {
          this._globalUIUtilsService.hide();
        }

      }
    }

    if (this.errorMessage !== '') {
      $('#errorModal').modal('show');

    }

    return routeUrl;
  }


  checkEditable() {
    if (this.tasacionForm.controls['estadoId'].value === '1100') {
      this.tasacionForm.controls['importeFacturable'].disable();
      this.tasacionForm.controls['importeEditable'].setValue(false);
      this.tasacionForm.controls['importeEditable'].disable();
    } else {
      if (this.tasacionForm.value.importeEditable == true) {
        this.tasacionForm.controls['importeFacturable'].enable();
      } else {
        this.tasacionForm.controls['importeFacturable'].disable();
      }
    }
  }

  displayButtons() {
    this.showOpenReclamacionBtn = this.modelo.estadoId === 910;
    this.showOpenIncidenciaBtn = this.modelo.estadoId >= 400 && this.modelo.estadoId <= 900 && this.modelo.estadoId !== 700 && this.modelo.estadoId !== 1200;
    this.showCloseIncidenciaBtn = this.modelo.estadoId === ValoresEstadoTasacion.EnIncidencia;
    this.showCloseReclamacionBtn = this.modelo.estadoId === ValoresEstadoTasacion.ReclamacionCliente;
    this.showAnularReclamacion = (this.modelo.estadoId !== ValoresEstadoTasacion.TramitacionAlta) && (this.modelo.estadoId !== ValoresEstadoTasacion.Anulado);
    this.showAsignarPS = this.isEdit;

  }


  // -----------------------------------------------Variables de validación----------------------------------//
  get entidadFinancieraId() { return this.tasacionForm.get('entidadFinancieraId'); }
  get clienteId() { return this.tasacionForm.get('clienteId'); }
  get fechaPedido() { return this.tasacionForm.get('fechaPedido'); }
  get tipoInmuebleId() { return this.tasacionForm.get('tipoInmuebleId'); }
  get finalidadId() { return this.tasacionForm.get('finalidadId'); }
  get contratoId() { return this.tasacionForm.get('contratoId'); }
  get nPresupuesto() { return this.tasacionForm.get('nPresupuesto'); }
  get visita() { return this.tasacionForm.get('visita') }
  get descripcion() { return this.tasacionForm.get('descripcion') }
  get flujoTasacion() { return this.tasacionForm.get('flujoTasacion') }
  get tipoTasacion() { return this.tasacionForm.get('tipoTasacion') }
  get prescriptorId() { return this.tasacionForm.get('prescriptorId') }

  // getFormValidationErrors() {
  //   Object.keys(this.tasacionForm.controls).forEach(key => {

  //     const controlErrors: ValidationErrors = this.tasacionForm.get(key).errors;
  //     if (controlErrors != null) {
  //       Object.keys(controlErrors).forEach(keyError => {
  //         console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
  //       });
  //     }
  //   });
  // }
  getFormValidationErrors() {


    const invalidFields = {}; // Objeto para almacenar campos inválidos y sus errores

    Object.keys(this.tasacionForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.tasacionForm.get(key).errors;
      if (controlErrors != null) {
        invalidFields[this.customFieldNamesError[key] || key] = controlErrors; // Utiliza el nombre personalizado si está definido
      }
    });

    // Construye un mensaje de error
    let errorMessage = 'Por favor, complete todos los campos requeridos:\n';
    for (const fieldName in invalidFields) {
      if (invalidFields.hasOwnProperty(fieldName)) {
        errorMessage += `${fieldName},\n`;
      }
    }

    errorMessage = errorMessage.replace(/,\n$/, '.');

    return errorMessage;
  }

  async isPrescriptor() {

    let canalEntradaControl = this.tasacionForm.controls['canalEntradaId'];

    if (canalEntradaControl !== undefined) {
      let canalEntradaId: number = this.tasacionForm.controls['canalEntradaId'].value;

      if (canalEntradaId !== null && canalEntradaId !== 0) {
        this.modelCanalEntrada = await this._canalEntradaService.get(canalEntradaId).toPromise();
        // console.log(this.modelCanalEntrada.esPrescriptor)
        if (this.modelCanalEntrada.esPrescriptor == true) {
          this.tasacionForm.get('prescriptorId').setValidators([Validators.required]);
          this.tasacionForm.get('prescriptorId').updateValueAndValidity();
        } else {
          this.tasacionForm.get('prescriptorId').clearValidators();
          this.tasacionForm.get('prescriptorId').updateValueAndValidity();
        }
      }
    }
  }

  async reopenVisit() {
    if (this.id !== 0) {

      await this.saveAsync();

      try {
        let result = await this._TasacionesService.reopenVisit(this.id).toPromise();
        this.errorMessage = '';
        this.tasacionForm.reset();
        this.getData();
      }
      catch (error) {
        this.errorMessage = ErrorHelper.GetClientError(error);
      }

    }
  }

  open(contentD) {
    // console.log(contentD);
    this.modalService.open(contentD, { size: 'lg' });
  }


  onAddTecnicos() {
    // console.log(this.tecnicosFormArray.length)

    //Cuando se pulse sobre el botón "Añadir técnico", creamos un nuevo formGroup,  y lo vamos añadiendo al formArray
    if (this.tecnicosFormArray.length < 3) {
      const newTecnicoFormGroup = this._fb.group({
        tecnicoID: [0, [Validators.required]],
        intervencion: [0],
        liqTecnicaAcordada: [0],
        liqTecnicaAcordada_Importe: [{ value: 0, disabled: true }],
        liqTecnicaAcordada_Porcentaje: [{ value: 0, disabled: true }]
      })

      this.tecnicosFormArray.push(newTecnicoFormGroup);
    }
    // 3 es el máximo de técnicos que se pueden añadir, así que cuando llegamos a 3, deshabilitamos el botón
    if (this.tecnicosFormArray.length === 3) {
      this.buttonAddTecnicoDisable = true;
    }

  }

  eliminarTecnico(index: number) {
    // Eliminamos al ténico seleccionado
    this.tecnicosFormArray.removeAt(index);

    // Habilitamos nuevamente el botón "Añadir Técnico" si es necesario
    if (this.tecnicosFormArray.length < 3) {
      this.buttonAddTecnicoDisable = false;
    }
  }

  async saveTecnicos(tasacionId: any) {
    await this._tecnicoService.postTecnicosAgregados(this.tecnicosFormArray.value, tasacionId).toPromise();
  }

  // async savePS(tasacionId: any) {
  //   var idPs = this.tasacionForm.controls['idps'].value;
  //   if (idPs == null || idPs == '' || idPs == undefined) {
  //     await this._psTasacionService.delete(this.psTasacion.id).toPromise();
  //   } else {
  //     this.ps_t = new PSTasacionModel();
  //     this.ps_t.tasacionId = tasacionId;
  //     this.ps_t.idps = this.tasacionForm.controls['idps'].value;

  //     await this._psTasacionService.post(this.ps_t).toPromise();
  //   }
  // }

  anularReclamacion() {
    this.tasacionForm.patchValue({
      estadoId: ValoresEstadoTasacion.Anulado
    });

    this.save();
  }

  closeReclamacion() {
    this.dialogConfig.data = {
      id: this.modelo.id
    }
    let dlgRef = this._dialog.open(TasacionReclamacionEditComponent, this.dialogConfig);
    dlgRef.afterClosed().subscribe(result => {
      if (result) {
        this.getData();
      }
    })
  }

  closeIncidencia() {
    this.dialogConfig.data = {
      id: this.modelo.id
    }
    let dlgRef = this._dialog.open(IncidenciaCloseComponent, this.dialogConfig);
    dlgRef.afterClosed().subscribe(result => {
      if (result) {
        this.getData();
      }
    })
  }

  async confirmAnswer(message: string): Promise<boolean> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "450px"
    dialogConfig.data = {
      title: 'Atención',
      confirmText: 'Confirmar',
      message: message,
    };
    const ref = this.matDialog.open(ModalDefaultComponent, dialogConfig);
    const result = await ref.afterClosed().toPromise();
    return result === true;
  }

  checkNextStatus(model: TasacionModel): { showConfirmation: boolean; message: string } {

    // if (model.estadoId == ValoresEstadoTasacion.EnCurso && model.fechaInformeEnviado !== null) {
    //   return {showConfirmation: true, message: ""}
    // }
    if (model.estadoId == ValoresEstadoTasacion.InformeEnviado && (model.fechaInformeValidado !== null || model.haSidoValidado)) {
      return { showConfirmation: true, message: "¿Está seguro que el informe está validado correctamente?. Esto modificará el estado a “validado”, contabilizará el tiempo invertido en la validación y generará una instrucción para facturar y entregar el informe." }
    }
    if (model.estadoId == ValoresEstadoTasacion.InformeValidado && (model.fechaInformeEntregadoCliente !== null || model.haSidoEntregado)) {
      return { showConfirmation: true, message: "¿Está seguro de que el informe está entregado? Esto modificará el estado a informe entregado y finalizará la tramitación del expediente" }
    }

    return { showConfirmation: false, message: "" }
  }


}
